import React from "react";
import { AppLayout } from "./app-layout";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { TaskProvider } from "@/lib/contexts/task-context";
import { WorkflowProvider } from "@/lib/contexts/workflow-context";
import GlobalNotifications from "@/components/GlobalNotifications";

export function RootLayout({ children }) {
    return (
        <TaskProvider>
            <WorkflowProvider>
                <ThemeProvider
                    attribute="class"
                    defaultTheme="system"
                    enableSystem
                    disableTransitionOnChange
                >
                    <AppLayout>{children}</AppLayout>
                    <Toaster />
                    <GlobalNotifications />
                </ThemeProvider>
            </WorkflowProvider>
        </TaskProvider>
    );
}
